import { Field, Form, Formik } from 'formik'
import { Button, Grid } from '@material-ui/core'
import { TextField } from 'formik-material-ui'
import { metodoPrograma } from '../../components/api'
import AutoComplete from '../../components/AutoComplete/AutoComplete'

export const Cadastro = ({ objeto, voltar }) => {
  const initialValues = {
    idNotificacao: objeto?.[0] || undefined,
    idUsuario: objeto?.[1] || undefined,
    dtEnvio: objeto?.[2] || undefined,
    dsTitulo: objeto?.[3] || undefined,
    dsConteudo: objeto?.[4] || undefined
  }

  const salva = async (values) => {

    const dados = {
      idUsuario: values.idUsuario,
      dsTitulo: values.dsTitulo,
      dsConteudo: values.dsConteudo
    }
    const res = await metodoPrograma('salva', dados)
    if (res.status) voltar()
  }
  
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, setFieldValue, submitForm }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <AutoComplete
                InputLabelProps={{ shrink: true }}
                label="User"
                metodo="listaUsuario"
                disabled={objeto?.[0] !== undefined}
                value={objeto?.[1]}
                onChange={(_, val) => {
                  setFieldValue(
                    'idUsuario',
                    Array.isArray(val) ? val[0][0] : '',
                  )
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                component={TextField}
                InputLabelProps={{ shrink: true }}
                name="dsTitulo"
                label="Title"
                disabled={objeto?.[0] !== undefined}
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                component={TextField}
                InputLabelProps={{ shrink: true }}
                name="dsConteudo"
                label="Content"
                disabled={objeto?.[0] !== undefined}
                fullWidth
                margin="dense"
                variant="outlined"
                multiline
                rows={4}
              />
            </Grid>         
            
              { objeto?.[0] === undefined &&
                <Grid
                  item
                  xs={12}
                  style={{ display: 'flex', flexDirection: 'row-reverse' }}
                >
                  <Button
                    onClick={submitForm}
                    disabled={isSubmitting}
                    variant="contained"
                    color="primary"
                    style={{ margin: '5px' }}
                  >
                    Send
                  </Button>
                  <Button
                    onClick={voltar}
                    variant="contained"
                    color="secondary"
                    style={{ margin: '5px' }}
                  >
                    Cancel
                  </Button>
                </Grid>
              }
              
          </Grid>
        </Form>
      )}
    </Formik>
  )
}
